import React, { useEffect } from "react";
import {
  Badge,
  Col,
  FloatingLabel,
  Form,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import EmailTextBox from "./_EmailTextBox";
import PropTypes from "prop-types";
import ShortlinksList from "../../pages/Generic/_ShortlinksList";

const EmailMessageControl = ({
  name,
  values,
  setValues,
  onChange,
  listShortLinks,
  fieldsInfo,
}) => {
  useEffect(() => {
    let emailWithTemplate = values.mailmessage;
    let result;
    try {
      var pattern = RegExp("{(.*?)}", "g");
      while ((result = pattern.exec(emailWithTemplate))) {
        // Do something with result[0].

        try {
          var currentK = fieldsInfo.filter(
            (item) => "{" + item.vc_keycolumn + "}" == result[0]
          );
          emailWithTemplate = emailWithTemplate.replace(
            result[0],
            currentK[0].vc_value
          );
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }

    setValues({
      ...values,
      ["emailtemplate"]: emailWithTemplate
        .replaceAll("{", "")
        .replaceAll("}", ""),
    });
  }, [values.mailmessage]);

  const clickLink = (link) => {
    //  setMessageText(link);
    setValues({
      ...values,
      mailmessage: values.mailmessage + " " + link + " ",
    });
  };
  return (
    <>
      <Row>
        <Col sm={12}>
          <div>
            <FloatingLabel label="Asunto" className="mb-3">
              <Form.Control
                type="text"
                name="subject"
                id="Asunto"
                value={values.subject}
                required
                onChange={(event) => {
                  onChange(event);
                }}
                placeholder="Ingrese un Asunto"
              />
            </FloatingLabel>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div style={{ height: "400px" }}>
            <EmailTextBox
              name={name}
              defaultValue={values.mailmessage}
              changeHandler={onChange}
            ></EmailTextBox>
          </div>
        </Col>
      </Row>
      <Row>
        {values.emailtemplate && (
          <>
            <h5 className="PrevTitleModal">Previsualización:</h5>
            <div className="contenedo_msj">
              <div className="mensaje-izq">
                <div className="cuerpo_msj">
                  {
                    <div
                      className="msj-texto"
                      dangerouslySetInnerHTML={{
                        __html: values.emailtemplate,
                      }}
                    ></div>
                  }
                </div>
              </div>
            </div>
            <hr />
          </>
        )}
      </Row>
      <Col sm={12}>
        <Tabs id="fill-tab-example" className="tabsBottom" fill>
          <Tab eventKey="ShortLinks" title="Urls Cortas">
            {listShortLinks && (
              <div className="ShortLink" style={{ paddingTop: "10px" }}>
                <h6>
                  Al darle click se agregará la url corta relacionada con el
                  alias que aparece a continuación:
                </h6>
                <div className="AllLinks">
                  <>
                    {listShortLinks && (
                      <ShortlinksList
                        clickBadge={clickLink}
                        listShortLinks={listShortLinks}
                      />
                    )}
                  </>
                </div>
              </div>
            )}
          </Tab>

          <Tab eventKey="AddFields" title="Template">
            <div className="ShortLink" style={{ paddingTop: "10px" }}>
              <h6>
                Al darle click se agregará el campo relacionado con el alias que
                aparece a continuación:
              </h6>
              <div className="AllLinks">
                <>
                  {fieldsInfo &&
                    fieldsInfo.map((field) => {
                      return (
                        <>
                          <Badge
                            onClick={() => {
                              //   setMessageText(field.vc_keycolumn);
                              setValues({
                                ...values,
                                mailmessage:
                                  values.mailmessage +
                                  "{" +
                                  field.vc_keycolumn +
                                  "}",
                                parameters:
                                  (values.parameters
                                    ? values.parameters + " ,"
                                    : "") +
                                  field.vc_keycolumn +
                                  " ",
                              });
                            }}
                            bg="primary"
                          >
                            {field.vc_keycolumn}
                          </Badge>
                        </>
                      );
                    })}
                </>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Col>
    </>
  );
};
EmailMessageControl.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldsInfo: PropTypes.array.isRequired,
  setValues: PropTypes.func.isRequired,
  listShortLinks: PropTypes.array.isRequired,
};

export default EmailMessageControl;
